import React, { useEffect, useState } from 'react';
import { UpdateToast } from '@sf/shared';
import { onNeedRefresh } from './registerServiceWorker';

/**
 * Atualização do aplicativo instalado, sem reinstalar: a versão nova é baixada em segundo
 * plano e ativada quando o app vai para segundo plano sem operação em andamento, ou quando
 * o usuário toca em "Atualizar".
 */
export default function UpdatePrompt() {
  const [needRefresh, setNeedRefresh] = useState(false);

  useEffect(() => onNeedRefresh(setNeedRefresh), []);

  return <UpdateToast needRefresh={needRefresh} />;
}
